export default {
  W9: 1, //{value: 1, description: "W9"},
  INSURANCE_CERTIFICATE: 2, //{value: 2, description: "Insurance Certificate"}
};
